import axios from "../../axiosCF";
import { ICategoryAction } from "../../interfaces/action/ICategoryAction";
import { ICategory } from "../../interfaces/domain/ICategory";
import { ActionTypes } from "./actionTypes";

type TAction = ICategoryAction;

export const findCategoriesStart = (): TAction => {
  return {
    type: ActionTypes.CATEGORY_FIND_START,
  };
};

export const findCategoriesSuccess = (categories: ICategory[]): TAction => {
  return {
    type: ActionTypes.CATEGORY_FIND_SUCCESS,
    categories,
  };
};

export const findCategoriesFail = (error: string): TAction => {
  return {
    type: ActionTypes.CATEGORY_FIND_FAIL,
    error,
  };
};

export const findCategories = (): Function => {
  return async (dispatch: any): Promise<void> => {
    dispatch(findCategoriesStart());
    try {
      const response = await axios.get("/api/categories/find");
      dispatch(findCategoriesSuccess(response.data));
    } catch (error) {
      dispatch(findCategoriesFail(error as string));
    }
  };
};
